import { ModalContent, ModalBody, Modal, Button } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import SiteNavigation from 'src/components/header/siteNavigation';
import { SvgEllipse } from 'src/components/icons';
import SvgLogo2White from 'src/components/icons/logo-2-white';
import { imageOptimize } from 'src/service/image';
import RepplAvatar from './reppl-cover/reppl-avatar';

const RepplNotPublished = ({ reppl }: { reppl?: any }) => {
  const router = useRouter();

  return (
    <Modal isOpen onClose={() => {}}>
      <ModalContent maxW="100vw" w="100vw" h="100vh" borderRadius="none">
        <ModalBody p={0}>
          <div
            className="w-full h-full"
            style={{
              background:
                'url(/images/assets/reppl/reppl-not-published-bg.png)',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              display: 'grid',
              gridTemplateColumns: '100%',
              gridTemplateRows: 'auto 1fr auto',
            }}
          >
            <div>
              <SiteNavigation />
            </div>
            <div>
              <div className="w-full h-full flex justify-center items-center px-0 sm:px-5">
                <div
                  style={{
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06)',
                    backgroundColor: '#F4F7F6',
                    backgroundImage:
                      'url(/images/assets/reppl/reppl-not-published-bg-1.svg)',
                    maxHeight: '714px',
                  }}
                  className="w-full max-w-5xl h-full sm:rounded-2xl overflow-hidden"
                >
                  <div className="w-full h-full bg-gray-100 bg-opacity-90 flex flex-col justify-center items-center p-2 max-h-full sm:max-h-auto">
                    <h1 className="text-gray-900 font-semibold text-2xl mb-8 text-center">
                      This RE:PPL is not yet published.
                    </h1>
                    <div
                      style={{
                        borderRadius: '32px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06)',
                      }}
                      className="px-5 py-10 bg-white w-full max-w-lg mb-10 flex flex-col justify-center items-center"
                    >
                      <h1 className="text-black text-sm font-semibold mb-4">
                        RE:PPL
                      </h1>
                      <RepplAvatar
                        isLoading={router.isFallback}
                        rid={reppl?.id}
                        src={imageOptimize(reppl?.avatarImgURL)}
                        name={reppl?.title}
                        isOwner={false}
                      />
                      <h1 className="mt-4 text-4xl text-black font-medium text-center">
                        {reppl?.reppl?.title}
                      </h1>
                      <h2 className="mt-2 text-black text-xl font-medium text-center">
                        {reppl?.reppl?.headline}
                      </h2>
                      <div className="flex items-center">
                        <p className="text-black text-sm font-medium">
                          {reppl?.reppl?.episodeCount} creations
                        </p>
                        <SvgEllipse fontSize="3px" mx="10px" color="gray.300" />
                        <p className="text-black text-sm font-medium">
                          {reppl?.reppl?.followerCount} followers
                        </p>
                      </div>
                    </div>
                    <Button
                      rounded="ellipse"
                      width="max-content"
                      onClick={() => {
                        router.push({
                          pathname: '/agora',
                        });
                      }}
                      px="32px"
                      py="10px"
                    >
                      <span className="font-semibold text-sm lg:text-base">
                        Back
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex flex-col items-center pb-10 px-5 pt-5">
                <SvgLogo2White alt="1TM Logo" fontSize="32px" />
                <p className="text-white text-xs font-medium mt-4">
                  © 2021 1TM All rights reserved
                </p>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RepplNotPublished;
